import { useState } from "react";

export function useSelectedItems() {
    const [selectedItems, setSelectedItems] = useState([]);
    return { selectedItems, setSelectedItems };
}